module.exports = (__parcel__import__("jVnxX")).then(() => parcelRequire('lkF08'));